import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { GridView } from './GridView';
import { prettyCoordenadaGMS, prettyDistancia, prettyVertice } from '../Cadastro/context/RequerimentoContext';
var DadosCartograficosView = function (_a) {
    var _b;
    var dados = _a.dados;
    var dadosCart = useCallback(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return [
            {
                label: 'Vértide De',
                value: (_a = prettyVertice(dados === null || dados === void 0 ? void 0 : dados.verticeDe)) !== null && _a !== void 0 ? _a : ''
            },
            {
                label: 'Vértide Para',
                value: (_b = prettyVertice(dados === null || dados === void 0 ? void 0 : dados.verticePara)) !== null && _b !== void 0 ? _b : ''
            },
            {
                label: 'Azimute (°)',
                value: (_c = prettyCoordenadaGMS(dados === null || dados === void 0 ? void 0 : dados.azimute)) !== null && _c !== void 0 ? _c : ''
            },
            {
                label: 'Distância (m)',
                value: (_d = prettyDistancia(Number(dados === null || dados === void 0 ? void 0 : dados.distancia))) !== null && _d !== void 0 ? _d : ''
            },
            {
                label: 'Longitude (°) DE',
                value: (_e = prettyCoordenadaGMS(dados === null || dados === void 0 ? void 0 : dados.longitudeDe)) !== null && _e !== void 0 ? _e : ''
            },
            {
                label: 'Latitude (°) DE',
                value: (_f = prettyCoordenadaGMS(dados === null || dados === void 0 ? void 0 : dados.latitudeDe)) !== null && _f !== void 0 ? _f : ''
            },
            {
                label: 'Longitude (°) PARA',
                value: (_g = prettyCoordenadaGMS(dados === null || dados === void 0 ? void 0 : dados.longitudePara)) !== null && _g !== void 0 ? _g : ''
            },
            {
                label: 'Latitude (°) PARA',
                value: (_h = prettyCoordenadaGMS(dados === null || dados === void 0 ? void 0 : dados.latitudePara)) !== null && _h !== void 0 ? _h : ''
            },
        ];
    }, [dados === null || dados === void 0 ? void 0 : dados.verticeDe, dados === null || dados === void 0 ? void 0 : dados.verticePara, dados === null || dados === void 0 ? void 0 : dados.azimute, dados === null || dados === void 0 ? void 0 : dados.distancia, dados === null || dados === void 0 ? void 0 : dados.longitudeDe, dados === null || dados === void 0 ? void 0 : dados.longitudePara, dados === null || dados === void 0 ? void 0 : dados.latitudeDe, dados === null || dados === void 0 ? void 0 : dados.latitudePara]);
    return (_jsx(_Fragment, { children: (_b = dadosCart()) === null || _b === void 0 ? void 0 : _b.map(function (option, index) { return (_jsx(GridView, { index: index, option: option }, "grid_field_".concat(index === null || index === void 0 ? void 0 : index.toString()))); }) }));
};
export default DadosCartograficosView;
